import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=2e0ecd76&scoped=true"
import script from "./dictionary.vue?vue&type=script&lang=js"
export * from "./dictionary.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=2e0ecd76&prod&scoped=true&lang=css&external"
import style1 from "./dictionary.vue?vue&type=style&index=1&id=2e0ecd76&prod&scoped=true&lang=css"
import style2 from "./dictionary.vue?vue&type=style&index=2&id=2e0ecd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ecd76",
  null
  
)

export default component.exports